import React from 'react'

const Header = () => {
  return (
    <div>
      <h1 className="font-weight-light display-1 text-center">Hike Finder</h1>
    </div>
  )
}

export default Header;
